import { render } from "./ListTabItems.vue?vue&type=template&id=57041ad1"
import script from "./ListTabItems.vue?vue&type=script&lang=js"
export * from "./ListTabItems.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__